export default "__VITE_ASSET__DXyq8QPt__"